/* tslint:disable */
/* eslint-disable */
/**
 * data-center
 * data-center
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OmniGenerateIFrameUrlForReportBuilderRequest
 */
export interface OmniGenerateIFrameUrlForReportBuilderRequest {
    /**
     * 
     */
    user_timezone?: string;
}

/**
 * Check if a given object implements the OmniGenerateIFrameUrlForReportBuilderRequest interface.
 */
export function instanceOfOmniGenerateIFrameUrlForReportBuilderRequest(value: object): value is OmniGenerateIFrameUrlForReportBuilderRequest {
    return true;
}

export function OmniGenerateIFrameUrlForReportBuilderRequestFromJSON(json: any): OmniGenerateIFrameUrlForReportBuilderRequest {
    return OmniGenerateIFrameUrlForReportBuilderRequestFromJSONTyped(json, false);
}

export function OmniGenerateIFrameUrlForReportBuilderRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): OmniGenerateIFrameUrlForReportBuilderRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'user_timezone': json['user_timezone'] == null ? undefined : json['user_timezone'],
    };
}

export function OmniGenerateIFrameUrlForReportBuilderRequestToJSON(json: any): OmniGenerateIFrameUrlForReportBuilderRequest {
    return OmniGenerateIFrameUrlForReportBuilderRequestToJSONTyped(json, false);
}

export function OmniGenerateIFrameUrlForReportBuilderRequestToJSONTyped(value?: OmniGenerateIFrameUrlForReportBuilderRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'user_timezone': value['user_timezone'],
    };
}

